import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/beratung/$taxAdvisoryId")({
  component: TaxAdvisoryLayoutComponent,
});

function TaxAdvisoryLayoutComponent() {
  return <Outlet />;
}
